import { put, takeLatest } from 'redux-saga/effects';
import { firestoreRef } from '../utils/firebase';
import { SettingsActions, fetchViewerTypeReturn } from '../actions/settings.actions';

const settingsCollection = firestoreRef.collection('settings');

function* fetchViewerTypeSaga(action) {
    const viewerType = yield settingsCollection
        .doc('viewer')
        .get()
        .then(doc => {
            const data = doc.data();
            return data ? data.type : undefined;
        })
        .catch(e => {
            return e.code;
        });

    yield put(fetchViewerTypeReturn(viewerType));
}

export function* settingsSaga() {
    yield takeLatest(SettingsActions.FETCH_VIEWER_TYPE, fetchViewerTypeSaga);
}
